
	export default {
		data() {
			return {
				title: 'Master Guitar Faster: Interactive Courses, Tools, and World-Class Instructors',
				placeholder: `Search by genre, instrument, or style...`,
				items: [
					`🎸 Hone your skills with in-depth courses from world-class instructors.`,
					`🎥 80,000+ video lessons, find courses tailored to beginners, intermediates, or advanced players across every style.`,
					`⚡ Accelerate your progress with interactive tabs, slow-motion playback, and more unique learning tools.`
				],
				sub: `Not sure where to start? <a href="#" style="color:#9B3BCC !important">Click here</a> and we'll recommend the perfect course for you!`,
				loadedAutocomplete: false
			}
		},
		            created(){
                    if(process.client && typeof document !== 'undefined'){
				const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js']
				const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions']
				const { algoliasearch } = window['algoliasearch']

				const appId = 'D96IXX9O9V';
				const apiKey = 'b343960d038b6a72de641c58713f58f6';
				const searchClient = algoliasearch(appId, apiKey);

				function tfSuggestionPlugin(searchModel){
					return createQuerySuggestionsPlugin({
					  transformSource({ source, onTapAhead }) {
					  	return {
				        getItems({ query }) {
				          return getAlgoliaResults({
				            searchClient,
				            queries: [
				              {
				                indexName: `staging_truefire_${searchModel}_en`,
				                query,
				              },
				            ],
				          });
				        },
				        getItemUrl({ item }) {
				        	let url
			          	if(item.guid.includes('COURSE')) url = item.link
			        		else if(item.guid.includes('EDUCATOR')) url = `/e${item.authorid}`
				          return url
				        },
								templates: {
				          item({ item, html }) {
					          let url = item.title
				        		if(url.includes('(Premium)')) url = url.replace('(Premium)', '')
					          return html`<a href="/search/?q=${encodeURIComponent(url)}" style="display:block;">
				            	${item.title}
					            </a>`
				          },
								},
								onSelect({setIsOpen}){
									setIsOpen(true)
								}
					  	}
					  }
					});
				}

				this.loadedAutocomplete = true
				const coursesSuggestionPlugin = tfSuggestionPlugin('courses'),
					jamsSuggestionPlugin = tfSuggestionPlugin('jams'),
					educatorsSuggestionPlugin = tfSuggestionPlugin('educators')

				let mobileHeroIsFocused
				this.$nextTick(() => {
					this.$parent.$parent.$parent.autocompletes.push(
						autocomplete({
							insights: true,
							container: '#heroAutocomplete',
							openOnFocus: true,
							plugins: [coursesSuggestionPlugin, jamsSuggestionPlugin, educatorsSuggestionPlugin],
							placeholder: this.placeholder,
							onSubmit({state, event}){
								if(state.query) location.href = `/search/?q=${encodeURIComponent(state.query)}`
							},
							onStateChange({state}){
								mobileHeroIsFocused = state.isOpen
							},
							reshape({sources, sourcesBySourceId, state}){
								return sources.map((source, index) => {
									return {
										...source,
										getItems(){
											const items = source.getItems(),
												topItems = [], bottomItems = []
											for(let i = 0; i < items.length; i++){
												items[i]['_highlightResult'].title.matchedWords.length ?
													topItems.push(items[i]) :
													bottomItems.push(items[i])
											}
											return [...topItems, ...bottomItems].slice(0, 5)
										}
									}
								})
							}
						})
					)
					addEventListener("keypress", (event) => {
						                                            if(mobileHeroIsFocused && event.code.toLowerCase() == 'enter'){
                                                    const element = document.getElementById('autocomplete-0-input')
                                                    if (element) {
                                                        const value = element.value
                                                        location.href = `/search/?q=${encodeURIComponent(value)}`
                                                    }
                                            }
					})
				})
			}
		}
	}
